module.exports = __webpack_public_path__ + "static/media/check.562c299a.svg";